import { coreAllSalesforceUsersGetSlice } from './get';

export const { requestGetCoreAllSalesforceUsers, resetGetCoreAllSalesforceUsers } =
	coreAllSalesforceUsersGetSlice.asyncActionCreators;
